import React from 'react';

import { TableColumns } from '@models/column';
import { FeatureId } from '@models/feature';
import { FeatureDescriptor } from '@models/feature-descriptor';
import { FeatureLeaderboard } from '@models/feature-leaderboard';
import { useModelState, useWidgetModelContext } from '@utils/widget-model';
import { WidgetApi } from '@utils/widget-api';

import { ActionFooter } from '../../../components/ActionFooter';
import {
  FeatureDescriptorEditor,
  FeatureDescriptorEditorContextProvider,
  FeatureDescriptorDraft,
  useFeatureDescriptorEditorContext,
} from '../../../feature-descriptor/feature-descriptor-editor';
import { FeatureLeaderboardWidgetState } from '../../FeatureLeaderboardWidget';
import { DrawerMode } from './FeatureLeaderboardEntryDrawer';

const Footer = (props: {
  mode: DrawerMode;
  onClose: () => void;
  featureId: FeatureId;
  originFeatureId: FeatureId;
}) => {
  const [featureLeaderboard] = useModelState<
    FeatureLeaderboardWidgetState,
    'value'
  >('value');

  const Widget = WidgetApi.init(useWidgetModelContext());
  const [editor] = useFeatureDescriptorEditorContext();

  const validatedDraft = React.useMemo(
    () => FeatureDescriptorDraft.validate(editor),
    [editor]
  );

  return (
    <ActionFooter
      primaryButton={{ label: 'Save', isDisabled: !validatedDraft.success }}
      tertiaryButton={{ label: 'Cancel' }}
      onTertiaryButtonClick={props.onClose}
      onPrimaryButtonClick={() => {
        const entriesPositions = getEntriesPositions(
          featureLeaderboard,
          props.featureId,
          props.originFeatureId,
          props.mode
        );
        console.log(props.mode, entriesPositions);
        Widget.callMethod('save_feature', {
          id: props.featureId,
          descriptor: validatedDraft.data,
          entries_positions: entriesPositions,
        })
          .then(() => props.onClose())
          .catch(e => console.error(e));
      }}
    />
  );
};

export const FeatureLeaderboardEntryFeatureEditor = (props: {
  mode: DrawerMode;
  featureId: FeatureId;
  originFeatureId: FeatureId;
  featureDescriptor: FeatureDescriptor;
  tableColumns: TableColumns;
  onClose: () => void;
}) => {
  return (
    <FeatureDescriptorEditorContextProvider
      initFeatureDescriptor={props.featureDescriptor}
      tableColumns={props.tableColumns}
    >
      <FeatureDescriptorEditor
        featureDescriptor={props.featureDescriptor}
        tableColumns={props.tableColumns}
      />
      <Footer
        mode={props.mode}
        featureId={props.featureId}
        originFeatureId={props.originFeatureId}
        onClose={props.onClose}
      />
    </FeatureDescriptorEditorContextProvider>
  );
};

function getEntriesPositions(
  featureLeaderboard: FeatureLeaderboard,
  featureId: FeatureId,
  originFeatureId: FeatureId,
  mode: DrawerMode
) {
  return featureLeaderboard.allEntries.map(group =>
    group
      .map(feature =>
        mode === DrawerMode.Code || feature.feature.id !== originFeatureId
          ? feature.feature.id
          : [feature.feature.id, featureId]
      )
      .flat()
  );
}
